import React from 'react';
import { Switch, withStyles, Theme, createStyles, makeStyles, FormControlLabel } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import ICommonFormProps from '../interfaces/ICommonFormProps';
import { generateRegister } from '../utils';
import { useWatch } from 'react-hook-form';

export const StyleSwitch = withStyles((theme: Theme) =>
    createStyles({
        root: {
            float: 'right',
            padding: '3px',
        },
        thumb: {
            backgroundColor: '#FFFFFF',
            borderRadius: '4px',
        },
        track: {
            backgroundColor: '#F3F4F9',
            opacity: '1 !important',
        },
    }),
)(Switch);

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        wrapper: {
            display: 'flex',
            // flexDirection: "row-reverse",
            alignItems: 'center',
            margin: '0 1rem',
            float: (props: IFormSwitchProps) => (props.noFloat ? 'none' : 'right'),
        },
        enabledDisabled: {
            margin: '0 1rem',
            fontSize: '0.9375rem',
            fontWeight: 600,
            color: '#212121',
            '@media (max-width: 1279px)': {
                display: 'none',
            },
        },
        label: {
            margin: '1rem',
        },
    }),
);

interface IFormSwitchProps extends ICommonFormProps {
    labelPosition?: 'bottom' | 'top' | 'end' | 'start';
    hasStatus?: boolean;
    enabledText?: string;
    disabledText?: string;
    noFloat?: boolean;
}

/**Form switch component this component you have to register inside the component */
const FormSwitch = (props: IFormSwitchProps) => {
    const { t } = useTranslation();
    const classes = useStyles(props);

    const value = useWatch({
        control: props.control,
        name: props.keyName,
    });

    const getEnabledText = () => props.enabledText || t('misc.enabled');
    const getDisabledText = () => props.disabledText || t('misc.disabled');

    return (
        <div className={classes.wrapper}>
            <FormControlLabel
                control={
                    <StyleSwitch
                        key={props.keyName}
                        {...generateRegister(props)}
                        name={props.keyName}
                        color="primary"
                        defaultChecked={props.value ?? false}
                        disabled={props.disabled}
                        onChange={(_, value: any) => {
                            if (props.setValue) {
                                props.setValue(props.keyName, value, { shouldDirty: true });
                            }
                            if (props?.formProps?.onValueChange) {
                                props.formProps?.onValueChange!(value);
                            }
                        }}
                        data-component-name={'form-switch'}
                    />
                }
                label={props.formProps?.label && <div className={classes.label}>{t(props.formProps?.label)}</div>}
                labelPlacement={props.formProps?.labelPosition}
            />

            {props.formProps?.hasStatus && (
                <span className={classes.enabledDisabled}>{value ? getEnabledText() : getDisabledText()}</span>
            )}
        </div>
    );
};

FormSwitch.defaultProps = {
    labelPosition: 'top',
    hasStatus: false,
};

export default FormSwitch;
